import { StyledDropzoneFileRowContainer, StyledDropzoneFileRowTable, } from './FileDropzone.styles';
import { DropzoneFileRow } from './DropzoneFileRow';
import React from 'react';
export const DropzoneFileRowContainer = (props) => {
    const { files } = props;
    return (React.createElement(StyledDropzoneFileRowContainer, null,
        React.createElement(StyledDropzoneFileRowTable, null, files.map((file, index) => (React.createElement(DropzoneFileRow, { key: index, onDownloadClick: props.onDownloadClick
                ? props?.onDownloadClick(file)
                : undefined, onDeleteClick: props.onDeleteClick
                ? props?.onDeleteClick(file, index)
                : undefined, file: file }))))));
};
export default DropzoneFileRowContainer;
